export default __webpack_public_path__ + "assets/images/47e4cd055013fabaa6c684a3f5ced0d6.jpg";